<div aria-live="polite" class="screen-reader">{liveRegionText}</div>
{#if visible}
    <div class:prom-loading-spinner-page={pageLoading}>
        <div class="prom-loading-spinner {sizeClass}"
            role="progressbar"
            aria-label={label} 
            aria-valuemin={valueMin}
            aria-valuemax={valueMax}
            aria-valuenow={valueNow}
            aria-valuetext={valueText}>
            <div class="prom-loading-spinner__spinner {iconClass}"></div>
        </div>
    </div>
{/if}

<script>
    /** @type {'small'|'medium'|'large'} */
    export let size = 'medium';
    export let iconClass = '';
    export let label;
    export let statusText = undefined;
    export let visible = false;
    export let pageLoading = false;

    export let progressEnabled = false;
    export let progressMin = 0;
    export let progressMax = 100;
    export let progressValue = 0;
    export let progressText = undefined;

    $: sizeClass = `prom-loading-spinner--${size}`;
    $: valueMin = progressEnabled ? progressMin : undefined;
    $: valueMax = progressEnabled ? progressMax : undefined;
    
    $: valueNow = progressEnabled 
        ? (!isNaN(progressValue) ? progressValue : 0)
        : (statusText ? 0 : undefined);
    
    $: valueText = progressEnabled 
        ? (progressText ? progressText : '')
        : statusText;

    $: liveRegionText = getLiveRegionText(visible, statusText, progressEnabled, progressText);

    $: {
        document.body.inert = visible && pageLoading;
        document.body.classList.toggle("disable-scroll", visible && pageLoading);
    }
    
    function getLiveRegionText(visible, statusText, progressEnabled, progressText) {
        if (visible) {
            if (progressEnabled) {
                return progressText ? progressText : '';
            } else {
                return statusText ? statusText : '';
            }
        } else {
            return '';
        }
    }
</script>
